"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _EmbeddableSsml_serviceProvider, _EmbeddableSsml_speech;
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbeddableSsml = void 0;
const serviceTypes_1 = require("./serviceTypes");
const ssml_1 = require("./ssml");
var Action;
(function (Action) {
    Action["SAY"] = "say";
    Action["PAUSE"] = "pause";
})(Action || (Action = {}));
const actionsPerProvider = {
    [serviceTypes_1.ServiceProvider.POLLY]: new Set([Action.SAY, Action.PAUSE]),
    [serviceTypes_1.ServiceProvider.POLLY_NEURAL]: new Set([Action.SAY, Action.PAUSE]),
    [serviceTypes_1.ServiceProvider.GOOGLE]: new Set([Action.SAY, Action.PAUSE]),
    [serviceTypes_1.ServiceProvider.WELLSAID]: new Set([]),
    [serviceTypes_1.ServiceProvider.ELEVENLABS]: new Set([Action.SAY, Action.PAUSE]),
    [serviceTypes_1.ServiceProvider.TAVUS]: new Set([Action.SAY, Action.PAUSE]),
    [serviceTypes_1.ServiceProvider.DUMMY]: new Set([])
};
/**
 * This class is for external use, for building embeddable SSML
 */
class EmbeddableSsml {
    constructor(serviceProvider) {
        _EmbeddableSsml_serviceProvider.set(this, void 0);
        _EmbeddableSsml_speech.set(this, void 0);
        __classPrivateFieldSet(this, _EmbeddableSsml_serviceProvider, serviceProvider, "f");
        __classPrivateFieldSet(this, _EmbeddableSsml_speech, new ssml_1.Speech(serviceProvider), "f");
    }
    /**
     * This appends raw text into the <speak/> tag.
     * @param saying The raw text to insert into the speak tag.
     * @returns {EmbeddableSsml}
     */
    say(saying) {
        this.validateAction(Action.SAY);
        __classPrivateFieldGet(this, _EmbeddableSsml_speech, "f").say(saying);
        return this;
    }
    /**
     * Creates and inserts a break tag.
     * @param duration the duration represented by a number + either "s" for second or "ms" for milliseconds.
     * @returns {EmbeddableSsml}
     */
    pause(duration) {
        this.validateAction(Action.PAUSE);
        __classPrivateFieldGet(this, _EmbeddableSsml_speech, "f").pause(duration);
        return this;
    }
    /**
     * This method will construct an SSML string (without the <speak> tag)
     * @returns {string} An SSML string that can be embedded for supporting providers.
     */
    ssml() {
        return __classPrivateFieldGet(this, _EmbeddableSsml_speech, "f").ssml(true);
    }
    // Private methods //
    /**
     * This method validates that the action is supported by the provider.
     * @param action
     */
    validateAction(action) {
        var _a;
        if (!((_a = actionsPerProvider[__classPrivateFieldGet(this, _EmbeddableSsml_serviceProvider, "f")]) === null || _a === void 0 ? void 0 : _a.has(action))) {
            throw new Error(`Action ${action} is not supported for provider ${__classPrivateFieldGet(this, _EmbeddableSsml_serviceProvider, "f")}`);
        }
    }
}
exports.EmbeddableSsml = EmbeddableSsml;
_EmbeddableSsml_serviceProvider = new WeakMap(), _EmbeddableSsml_speech = new WeakMap();
//# sourceMappingURL=embeddableSsml.js.map